<template>
  <div class="ion-text-center">
    <!-- <img
      v-if="rangeImage !== ''"
      :src="require('@lib/assets/img/slider/' + rangeImage)"
    /> -->
    <ion-text color="primary">
      <b>{{ rangeLabel }}</b>
    </ion-text>
  </div>
  <ion-range
    :class="{
      '-img': rangeImage !== '',
      ['-' + rangeImage.split('.')[0]]: rangeImage !== '',
    }"
    v-model="selectedValue"
    :max="question.options.length - 1"
    :snaps="true"
    :ticks="false"
    mode="ios"
  ></ion-range>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-note>{{ question.options[0].value }}</ion-note>
      </ion-col>
      <ion-col class="ion-text-right" size="auto">
        <ion-note>{{
          question.options[question.options.length - 1].value
        }}</ion-note>
      </ion-col>
    </ion-row>
  </ion-grid>
  <next-question-button
    class="ion-margin-top"
    @click="
      $emit('done', {
        value: question.options[selectedValue].value,
        id: question.id,
      })
    "
  />
</template>

<script>
import {
  IonRange,
  IonGrid,
  IonRow,
  IonCol,
  IonNote,
  IonText,
} from "@ionic/vue";
import NextQuestionButton from "./NextQuestionButton";

export default {
  emits: ["done"],
  components: {
    IonRange,
    NextQuestionButton,
    IonGrid,
    IonRow,
    IonCol,
    IonNote,
    IonText,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      selectedValue: 0,
    };
  },
  computed: {
    rangeImage() {
      let result = "";
      const image = this.question.options[this.selectedValue].image;
      if (image) {
        result = image;
      }
      return result;
    },
    rangeLabel() {
      return this.question.options[this.selectedValue].value;
    },
  },
};
</script>

<style lang="scss">
ion-range {
  --bar-height: 5px;
  --knob-size: 35px;
  --bar-border-radius: 100px;
  --knob-background: var(--ion-color-primary);
  --bar-background-active: rgba(var(--ion-color-primary-rgb), 1);
  pointer-events: none;

  &.-s01::part(knob) {
    --knob-background: none;
    background: white url("../../assets/img/slider/s01.svg");
  }
  &.-s02::part(knob) {
    --knob-background: none;
    background: white url("../../assets/img/slider/s02.svg");
  }
  &.-s03::part(knob) {
    --knob-background: none;
    background: white url("../../assets/img/slider/s03.svg");
  }
  &.-s04::part(knob) {
    --knob-background: none;
    background: white url("../../assets/img/slider/s04.svg");
  }
  &.-s05::part(knob) {
    --knob-background: none;
    background: white url("../../assets/img/slider/s05.svg");
  }
}
ion-range::part(knob) {
  border: 6px solid white;
  box-sizing: border-box;
  pointer-events: auto;
}
</style>
